export default __webpack_public_path__ + "static/media/Group 2.ef73a8d1.svg";